export default function ({ store, from, to }) {
    if ( !store.getters['auth/isAuthenticatedGetter'] || !store.getters['auth/isStudentGetter']) {

        if (to.query.qrcode) {
            sessionStorage.setItem('qrRoute',to.query.qrcode);
        }

    }
    return false
  }
  